import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import parse from 'date-fns/parse';
import startOfToday from 'date-fns/startOfToday';
import React, { useEffect, useRef } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { useTheme } from 'styled-components';
import { getTimeFormat } from '../../../helpers/dates';
import * as Styled from './styles';
import { isLinesUsedInDates } from '../../../helpers/experiments';
import { useTranslation } from 'react-i18next';

interface Props {
  text: string;
  selected: boolean;
  hasTickets?: boolean;
  calendar?: boolean;
  scrollToSelectedItem: (value: number) => void;
  i18n: any;
  locale: any;
  t: (key: string, params?: any) => string;
  selectDate?: (date: any) => void;
  theme: any;
}

const MenuItem: React.FC<Props> = (props) => {
  const { text, selected, locale, hasTickets, selectDate } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const itemRef = useRef<HTMLDivElement>();

  useEffect(() => {
    const { scrollToSelectedItem, selected } = props;

    if (selected && theme.isMobile && itemRef?.current) {
      scrollToSelectedItem(itemRef.current.offsetLeft - 38);
    }
  }, [selected]);

  const handleClick = () => {
    if (selectDate) {
      selectDate(text);
    }
  };

  const { convertToAmPmTime, lang } = window.Widget.settings;
  const parsedDate = parse(`${text}`, 'yyyy-MM-dd HH:mm:SS', new Date());
  const currentYear = getYear(startOfToday());
  const eventYear = getYear(parsedDate);
  const year = currentYear === eventYear ? '' : ' yyyy';
  const timeFormat = getTimeFormat(convertToAmPmTime, lang);
  const formatDate = `EEEEEE, d MMM${year}, ${timeFormat}`;
  const date = format(parsedDate, formatDate, { locale }).replace('.', '');

  return (
    <Styled.MenuItem
      ref={itemRef}
      selected={selected}
      onClick={handleClick}
      isLines={isLinesUsedInDates()}
    >
      {hasTickets ? <Styled.DateHasTickets /> : <Styled.DateNoTickets />}
      <Styled.MenuItemDate>{date}</Styled.MenuItemDate>
      <Styled.MenuItemStatus>
        {hasTickets ? t('buy_ticket') : t('make_request')}
      </Styled.MenuItemStatus>
    </Styled.MenuItem>
  );
};

// @ts-ignore
export default enhanceWithClickOutside(MenuItem);
